import Widget from '../common/Widget'
import MapContainer from './MapContainer'
import Link from '@assets/NotificationContainerProps/Link.svg'
import { useParams } from 'react-router-dom'

type Props = {
  title?: string,
  interaction?: 'interactive' | 'view'
}

export default function DragSelectMap({ title = "תצוגה על גבי מפה", interaction = 'interactive', }: Props) {
  const { siteId } = useParams()
  const handleMenuAction = (action: string) => {
    // Handle map-specific menu actions
    switch (action) {
      case 'refresh':
        break
      case 'settings':
        break
      case 'export':
        break
      case 'fullscreen':
        break
      default:
        break
    }
  }

  return (
    <Widget
      title={title}
      showMenuButton={false}
      height="100%"
      width="100%"
      onMenuAction={handleMenuAction}
      expandIcon={Link}
      expandHref={`/${siteId}/maps`}
      expandIconSize={15}
      minHeight={100}
      maxHeight="none"
      menuItems={[
        { label: 'Refresh Map', action: 'refresh' },
        { label: 'Map Settings', action: 'settings' },
        { label: 'Export Data', action: 'export' },
        { label: 'Fullscreen', action: 'fullscreen' },
      ]}
    >
      <MapContainer interaction={interaction} />
    </Widget>
  )
}
